<template>
    <vx-expandable-card>
        <template v-slot:header> Name </template>

        <template v-slot:content>
            <vx-input
                autofocus
                :modelValue="props.modelValue"
                @update:modelValue="emit('update:modelValue', $event)"
                :error="props.error"
                size="lg"
                placeholder="Name"
            ></vx-input>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxInput } from '@voxie/frontend-components';

const props = defineProps({
    modelValue: {
        type: String,
        required: true,
    },
    error: String,
});

const emit = defineEmits(['update:modelValue']);
</script>
